import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";

const LANGUAGES = [
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
  { code: "fr", label: "FR" },
  { code: "de", label: "DE" },
];

export default function LanguageToggle({ language, setLanguage }) {
  return (
    <div className="flex items-center gap-1 bg-card/80 backdrop-blur-sm rounded-full px-2 py-1 border border-border">
      <Globe className="w-4 h-4 text-muted-foreground mr-1" />
      {LANGUAGES.map((lang) => (
        <Button
          key={lang.code}
          variant={language === lang.code ? "default" : "ghost"}
          size="sm"
          className={`rounded-full px-2 py-1 h-7 text-xs font-medium ${
            language === lang.code 
              ? "bg-primary text-primary-foreground" 
              : "hover:bg-accent"
          }`}
          onClick={() => setLanguage(lang.code)}
        >
          {lang.label}
        </Button>
      ))}
    </div>
  );
}
